import React, { useState, useEffect } from 'react';
import './Notes.css';

const Notes = () => {
    const [notes, setNotes] = useState([]);
    const [newNote, setNewNote] = useState({ titre: '', contenu: '' });
    const [searchTerm, setSearchTerm] = useState(''); // ÉTAT POUR LA RECHERCHE

    // Chargement initial
    useEffect(() => {
        fetchNotes();
    }, []);

    const fetchNotes = async () => {
        try {
            const response = await fetch('https://suivis.looktacom.fr/api/notes.php');
            if (response.ok) {
                const data = await response.json();
                setNotes(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération :", error);
        }
    };

    // LOGIQUE DE FILTRAGE
    const filteredNotes = notes.filter(note => 
        note.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        note.contenu.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleAddNote = async (e) => {
        e.preventDefault();
        if (!newNote.contenu) return;

        try {
            const response = await fetch('https://suivis.looktacom.fr/api/notes.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(newNote),
            });

            if (response.ok) {
                setNewNote({ titre: '', contenu: '' });
                fetchNotes(); // Recharger la liste
            }
        } catch (error) {
            console.error("Erreur lors de l'ajout :", error);
        }
    };

    const deleteNote = async (id) => {
        try {
            const response = await fetch(`https://suivis.looktacom.fr/api/notes.php?id=${id}`, {
                method: 'DELETE',
            });

            if (response.ok) {
                fetchNotes();
            }
        } catch (error) {
            console.error("Erreur lors de la suppression :", error);
        }
    };

    return (
        <div className="facturation-page">
            <header className="facture-header">
                <button className="btn-back" onClick={() => window.history.back()}>
                    <span>←</span> Retour
                </button>
                <div className="header-titles">
                    <h1>BLOC-NOTES</h1>
                    <p>Espace de brouillon libre</p>
                </div>
                
                {/* BARRE DE RECHERCHE DANS LE HEADER */}
                <div className="search-container">
                    <input 
                        type="text" 
                        className="search-inputnotes"
                        placeholder="Rechercher une note..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </header>

            <div className="billing-container note-grid-container">
                <form className="note-form" onSubmit={handleAddNote}>
                    <input 
                        type="text" 
                        placeholder="Titre de la note..."
                        value={newNote.titre}
                        onChange={(e) => setNewNote({...newNote, titre: e.target.value})}
                    />
                    <textarea 
                        placeholder="Écrivez quelque chose..."
                        value={newNote.contenu}
                        onChange={(e) => setNewNote({...newNote, contenu: e.target.value})}
                        required
                    />
                    <button type="submit" className="btn-add-note">Ajouter la note <span>📝</span></button>
                </form>

                <hr className="note-separator" />

                <div className="notes-grid">
                    {/* ON MAP SUR LES NOTES FILTRÉES */}
                    {filteredNotes.length > 0 ? (
                        filteredNotes.map(note => (
                            <div key={note.id} className="note-card">
                                <div className="note-card-header">
                                    <h3>{note.titre || 'Note sans titre'}</h3>
                                    <button className="btn-delete" onClick={() => deleteNote(note.id)}>×</button>
                                </div>
                                <p>{note.contenu}</p>
                                <span className="note-date">
                                    Posté le {new Date(note.date_creation).toLocaleDateString()}
                                </span>
                            </div>
                        ))
                    ) : (
                        <div className="empty-state">
                            <span className="empty-icon">
                                {searchTerm ? '🔍' : '📝'}
                            </span>
                            <h3>{searchTerm ? 'Aucun résultat trouvé' : 'Aucune note pour le moment'}</h3>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Notes;